import React, { useState } from "react";
import Header from "./Header";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

export default function Blog() {
  const [open, setOpen] = React.useState(0);
  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  return (
    <section className="min-h-[618px] lg:min-h-[815px] pt-5 lg:bg-circle lg:bg-no-repeat lg:bg-right-top mb-[100px]">
      <div className="container mx-auto">
        <Header />
      </div>

      <div className="mt-28 lg:mt-48 container text-left px-[7%] lg:ml-10">
        <h2
          data-aos="fade-down"
          data-aos-duration="1500"
          className="text-4xl text-green font-bold"
        >
          Insightful Blogs from Instructor
        </h2>
        <p
          data-aos="fade-down"
          data-aos-duration="1700"
          className="mt-14 text-lg text-gray-700"
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
          facilisi. Curabitur in libero neque. Integer et augue nec mi elementum
          convallis. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Nulla facilisi. Curabitur in libero neque. Integer et augue nec mi
          elementum convallis. Lorem ipsum dolor sit amet, consectetur
          adipiscing elit.
        </p>
      </div>

      <center>
        <div className="mt-20 px-[10%] text-left">
          <Accordion
            data-aos="fade-up"
            data-aos-delay="600"
            className=""
            open={open === 1}
            icon={<Icon id={1} open={open} />}
          >
            <AccordionHeader
              className={`${open === 1 ? "text-green text-xl " : "text-xl"}`}
              onClick={() => handleOpen(1)}
            >
              What is Classical Yoga?
            </AccordionHeader>

            <AccordionBody className="text-md lg:px-3">
              <img
                className="h-[350px] my-5 w-full"
                src="https://th.bing.com/th/id/R.59ad9d5f67e8816ef66daf0f66880ba2?rik=htKj6VI2ClLBvw&riu=http%3a%2f%2f9cover.com%2fimages%2fccovers%2f1465145745yoga-in-nature.jpg&ehk=KCqKvFmiRpv2EyXnWu%2beqDu%2bY7g5zo3iqIQyvp3tjEE%3d&risl=&pid=ImgRaw&r=0"
                alt="blogImg"
              />
              We&apos;re not always in the position that we want to be at.
              We&apos;re constantly growing. We&apos;re constantly making
              mistakes. We&apos;re constantly trying to express ourselves and
              actualize our dreams. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Nulla facilisi. Curabitur in libero neque.
              Integer et augue nec mi elementum convallis. Lorem ipsum dolor sit
              amet, consectetur adipiscing elit. Nulla facilisi. Curabitur in
              libero neque. Integer et augue nec mi elementum convallis. Lorem
              ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum
              dolor sit amet, consectetur adipiscing elit. Nulla facilisi.
              Curabitur in libero neque. Integer et augue nec mi elementum
              convallis. Lorem ipsum dolor sit amet, consectetur adipiscing
              elit. Nulla facilisi. Curabitur in libero neque. Integer et augue
              nec mi elementum convallis. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit. <br /> <br />
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
              facilisi. Curabitur in libero neque. Integer et augue nec mi
              elementum convallis. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Nulla facilisi. Curabitur in libero neque.
              Integer et augue nec mi elementum convallis. Lorem ipsum dolor sit
              amet, consectetur adipiscing elit.
            </AccordionBody>
          </Accordion>
          <Accordion
            data-aos="fade-up"
            data-aos-delay="700"
            className="mt-8"
            open={open === 2}
            icon={<Icon id={2} open={open} />}
          >
            <AccordionHeader
              className={`${open === 2 ? "text-green text-xl " : "text-xl"}`}
              onClick={() => handleOpen(2)}
            >
              How to use Material Tailwind?
            </AccordionHeader>
            <AccordionBody className="text-md lg:px-3">
              We&apos;re not always in the position that we want to be at.
              We&apos;re constantly growing. We&apos;re constantly making
              mistakes. We&apos;re constantly trying to express ourselves and
              actualize our dreams. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Nulla facilisi. Curabitur in libero neque.
              Integer et augue nec mi elementum convallis. Lorem ipsum dolor sit
              amet, consectetur adipiscing elit. Nulla facilisi. Curabitur in
              libero neque. Integer et augue nec mi elementum convallis. Lorem
              ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum
              dolor sit amet, consectetur adipiscing elit. Nulla facilisi.
              Curabitur in libero neque. Integer et augue nec mi elementum
              convallis. Lorem ipsum dolor sit amet, consectetur adipiscing
              elit. Nulla facilisi. Curabitur in libero neque. Integer et augue
              nec mi elementum convallis. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit.
            </AccordionBody>
          </Accordion>
          <Accordion
            data-aos="fade-up"
            data-aos-delay="800"
            className="mt-8"
            open={open === 3}
            icon={<Icon id={3} open={open} />}
          >
            <AccordionHeader
              className={`${open === 3 ? "text-green text-xl " : "text-xl"}`}
              onClick={() => handleOpen(3)}
            >
              What can I do with Material Tailwind?
            </AccordionHeader>
            <AccordionBody className="text-md lg:px-3">
              We&apos;re not always in the position that we want to be at.
              We&apos;re constantly growing. We&apos;re constantly making
              mistakes. We&apos;re constantly trying to express ourselves and
              actualize our dreams. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Nulla facilisi. Curabitur in libero neque.
              Integer et augue nec mi elementum convallis. Lorem ipsum dolor sit
              amet, consectetur adipiscing elit. Nulla facilisi. Curabitur in
              libero neque. Integer et augue nec mi elementum convallis. Lorem
              ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum
              dolor sit amet, consectetur adipiscing elit. Nulla facilisi.
              Curabitur in libero neque. Integer et augue nec mi elementum
              convallis. Lorem ipsum dolor sit amet, consectetur adipiscing
              elit. Nulla facilisi. Curabitur in libero neque. Integer et augue
              nec mi elementum convallis. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit.
            </AccordionBody>
          </Accordion>
        </div>
      </center>
    </section>
  );
}
